import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';
import { VariaveisAmbiente } from 'config';

export function useDeleteRemoverTabelaPreco() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const deleteRemoverTabelaPreco = useCallback(
        (id: string) =>
            invocarApi({
                url: `/${VariaveisAmbiente.apiVersion}/tabelapreco/${id}`,
                method: 'DELETE',
                enviarTokenUsuario: true,
            }),
        [invocarApi],
    );

    return {
        ...outrasPropriedades,
        deleteRemoverTabelaPreco,
    };
}
